export const getApiUrl = () => import.meta.env.VITE_API_URL;
export const isProd = () => import.meta.env.VITE_ENV === "prod";
export const isDev = () => import.meta.env.VITE_ENV === "dev";
